import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39748586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100" }
const _hoisted_2 = { class: "view-tenant-review-header w-100 d-flex align-items-center justify-content-between w-100" }
const _hoisted_3 = { class: "d-flex align-items-center view-tenant-review-content w-100" }
const _hoisted_4 = { class: "profile-info w-100" }
const _hoisted_5 = { class: "d-flex align-items-center rating w-100" }
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = { class: "name mb-0" }
const _hoisted_8 = {
  key: 0,
  style: {"margin-left":"1em"}
}
const _hoisted_9 = {
  key: 1,
  style: {"margin-left":"1em"}
}
const _hoisted_10 = { class: "d-flex align-items-center other-details" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center type" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-user icon" }),
  /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Agency")
], -1))
const _hoisted_12 = { class: "d-flex align-items-center phone" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt icon" }, null, -1))
const _hoisted_14 = { class: "text" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "d-flex align-items-center mail" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "far fa-envelope icon" }, null, -1))
const _hoisted_18 = { class: "text" }
const _hoisted_19 = ["href"]
const _hoisted_20 = { class: "d-flex align-items-center" }
const _hoisted_21 = { class: "dropdown d-inline-block" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-icon dropdown-toggle",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ellipsis-v" })
  ])
], -1))
const _hoisted_23 = { class: "dropdown-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_StatusIndicator = _resolveComponent("StatusIndicator")!
  const _component_AgencyDetails = _resolveComponent("AgencyDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Logo, {
          id: _ctx.agency?.id,
          "border-radius": false,
          style: {"margin-right":"10px"}
        }, null, 8, ["id"]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.agency?.business_name), 1),
              (_ctx.agency?.business_name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                    _createVNode(_component_StatusIndicator, {
                      negativeIndicator: _ctx.getStatus.negativeIndicator,
                      "text-status": _ctx.getStatus.text,
                      modelValue: _ctx.getStatus.value,
                      "text-color": _ctx.getStatus.color
                    }, null, 8, ["negativeIndicator", "text-status", "modelValue", "text-color"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.agency?.business_name)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                    _createVNode(_component_StatusIndicator, {
                      negativeIndicator: `bi bi-x-circle`,
                      modelValue: _ctx.abnStatus.value,
                      "text-status": _ctx.abnStatus.text,
                      "text-color": _ctx.abnStatus.color
                    }, null, 8, ["modelValue", "text-status", "text-color"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("a", {
                  href: `tel: ${_ctx.agency?.business_mobile_number}`
                }, _toDisplayString(_ctx.agency?.business_mobile_number || 'Not Specified'), 9, _hoisted_15)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createElementVNode("span", _hoisted_18, [
                _createElementVNode("a", {
                  href: `mailto: ${_ctx.agency?.business_email_address}`
                }, _toDisplayString(_ctx.agency?.business_email_address), 9, _hoisted_19)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("button", {
          class: "btn btn-icon",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.shownDetails = !_ctx.shownDetails), ["stop"]))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.chevronClass)
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("ul", _hoisted_23, [
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: "dropdown-item",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMakeAffiliate && _ctx.handleMakeAffiliate(...args)))
              }, "Make Affiliate")
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", {
                  disabled: _ctx.businessSuspended,
                }]),
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBusinessSuspension && _ctx.handleBusinessSuspension(...args)))
              }, "Suspend", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", {
                  disabled: _ctx.businessApproved,
                }]),
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleBusinessApproval && _ctx.handleBusinessApproval(...args)))
              }, "Approve", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("a", {
                class: _normalizeClass(["dropdown-item", {
                  disabled: _ctx.businessDeleted,
                }]),
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleDeleteBusiness && _ctx.handleDeleteBusiness(...args)))
              }, "Delete", 2)
            ])
          ])
        ])
      ])
    ]),
    (_ctx.shownDetails)
      ? (_openBlock(), _createBlock(_component_AgencyDetails, {
          key: 0,
          agency: _ctx.agencyDetails,
          "abn-approved": _ctx.abnApproved,
          "business-approved": _ctx.businessApproved,
          "business-suspended": _ctx.businessSuspended,
          "business-deleted": _ctx.businessDeleted
        }, null, 8, ["agency", "abn-approved", "business-approved", "business-suspended", "business-deleted"]))
      : _createCommentVNode("", true)
  ]))
}